import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BizzmineComponent } from './bizzmine.component';
import { AuthGuard } from 'app/shared/guards/auth.guard';

const routes: Routes = [
    {
        path: '',
        component: BizzmineComponent,
        canActivateChild: [AuthGuard],
        children: [
            {path: 'list', component: BizzmineComponent, data: { title: 'main.nav.links.bizzmine' }}
        ]
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BizzmineRoutingModule { }
